import script from "./Every24HoursReportPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./Every24HoursReportPreview.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__